export default class AiImageFileReader
{

	constructor()
	{
		
	}

	read(fileObject)
	{
		const c = this;

		c.fileReader = new FileReader();
		c.fileReader.o = c;
		c.fileReader.addEventListener('load', c.onFileRead);
		c.fileReader.addEventListener('error', c.onFileReadError);
		c.fileReader.readAsDataURL(fileObject);

		return new Promise((resolve, reject) =>
		{
			c.fsResolve = resolve;
			c.fsReject = reject;
		});
	}

	onFileReadError(er)
	{
		const c = this.o;

		c.removeFileReadListeners();
		c.fsReject('AiImageFileReader: Error reading file with FileReader.', er);
	}

	removeFileReadListeners()
	{
		const c = this;
		
		c.fileReader.removeEventListener('load', c.onFileRead);
		c.fileReader.removeEventListener('error', c.onFileReadError);
	}

	onFileRead()
	{
		const c = this.o;
		
		c.removeFileReadListeners();
		c.image = new Image();
		c.image.o = c;
		c.image.addEventListener('load', c.onImageLoaded);
		c.image.addEventListener('error', c.onImageLoadError);
		c.image.src = c.fileReader.result;
	}

	onImageLoaded()
	{
		const c = this.o;

		c.removeImageLoadListeners();
		c.fsResolve(c.image);
	}

	onImageLoadError(er)
	{
		const c = this.o;

		c.removeImageLoadListeners();
		c.fsReject('AiImageFileReader: Error reading image "src".', er);
	}

	removeImageLoadListeners()
	{
		const c = this;

		c.image.removeEventListener('load', c.onImageLoaded);
		c.image.removeEventListener('error', c.onImageLoadError);
	}

}